import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { DuenoFincaAsignadoResponse } from "../../../shared/response/terceros/FincaMapaResponse";
import { FincaAsignarClientePayload } from "../../../shared/services/api/payload/terceros/FincaAsignarClientePayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Suma un cliente dueño a una finca existente (`FincasPlataformaService.AsignarCliente`, gRPC). La finca no
 * se copia: los dueños comparten AOI, lotes y datos. No alimenta ningún listado: el mapa suma el dueño solo.
 */
export class FincaAsignarClienteService extends ServiceSaveBase<DuenoFincaAsignadoResponse, FincaAsignarClientePayload> {
  /** gRPC-Web (`AsignarCliente`): `id` del payload es la finca. Error si ya es dueño o si el nombre se repite. */
  protected async sendSave(p: FincaAsignarClientePayload): Promise<DuenoFincaAsignadoResponse> {
    const r = await grpcCall(() => grpcClient(FincasPlataformaService).asignarCliente({
      fincaId: p.id ?? "",
      clienteId: p.clienteId,
      nombre: p.nombre,
    }));
    return { id: r.clienteId, isEliminado: false, clienteId: r.clienteId, clienteNombre: r.clienteNombre, nombreFinca: r.nombreFinca };
  }
}
